import gql from 'graphql-tag';

export default gql`
    mutation AllocatePartial($input: AllocatePartialInput) {
        allocatePartial(input: $input) {
            errors
        }
    }
`;
